import React from "react";
import classNames from "classnames/bind";
import styles from "./NewsDetail.module.scss";
import { FaPlus, FaTimes } from "react-icons/fa";
import CustomEditor from "../commons/Editor/Editor";
import dayjs from "dayjs";

const cx = classNames.bind(styles);

export default function NewsDetail({
  id,
  data,
  tabButtons,
  currentItem,
  changeItem,
  disabledLocales,
  handleChange,
  handleChangeImage,
  handleCustomImageUpload,
  imageInputRef,
  handleRemoveImage,
  handlePreview,
  previewImage,
  editorRef,
  handleEditorChange,
  handleEditorImageUpload,
  handleSubmit,
  handleEdit,
}) {
  return (
    <>
      <div className={cx("tab_box")}>
        {tabButtons.map((tab, index) => {
          const isActive = currentItem.id === tab.id;
          const isDisabled = disabledLocales.includes(tab.locale);

          return (
            <button
              key={tab.id}
              onClick={() => {
                if (id || isDisabled) return;
                changeItem(index);
              }}
              disabled={isDisabled}
              className={cx(
                "tab_button",
                isActive && "tab_button_active",
                isDisabled && "tab_button_disabled",
                !id && "tab_button_editable"
              )}
            >
              {tab.tab}
            </button>
          );
        })}
      </div>
      <div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <label className={cx("label")}>제목</label>
            <input
              type="text"
              className={cx("input")}
              name="title"
              value={data?.title || ""}
              onChange={handleChange}
              placeholder="제목을 입력해 주세요."
            />
          </div>
          <div className={cx("input_box")}>
            <label className={cx("label")}>소식 링크</label>
            <input
              type="text"
              className={cx("input")}
              name="link"
              value={data?.link || ""}
              onChange={handleChange}
              placeholder="소식 관련 링크를 입력해 주세요."
            />
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <label className={cx("label")}>썸네일 이미지</label>
            <div className={cx("input_box_image")}>
              <input
                type="file"
                className={cx("hide_input")}
                name="images"
                accept="image/*" // 이미지 파일만 선택하도록 제한
                multiple
                onChange={handleChangeImage}
                ref={imageInputRef}
              />
              <button
                className={cx("image_button")}
                onClick={handleCustomImageUpload}
              >
                <FaPlus className={cx("image_button_icon")} />
              </button>
              {data?.images?.map((image, index) => (
                <div key={index} className={cx("image_preview_box")}>
                  <img
                    className={cx("image")}
                    src={image}
                    alt={image}
                    onClick={() => handlePreview(image)}
                  />
                  <button
                    className={cx("remove_button")}
                    onClick={() => handleRemoveImage(index)}
                    type="button"
                  >
                    <FaTimes />
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className={cx("input_box")}>
            <label className={cx("label")}>소식 날짜</label>
            <input
              type="date"
              className={cx("input")}
              name="date"
              value={dayjs(data?.date).format("YYYY-MM-DD") || ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box", "input_box_editor")}>
            <label className={cx("label")}>소식 내용</label>
            <CustomEditor
              key={`${currentItem.locale}-${data.locale}`}
              name="content"
              editorRef={editorRef}
              initialValue={data?.content}
              handleEditorChange={handleEditorChange}
              handleEditorImageUpload={handleEditorImageUpload}
              placeholder="소식을 작성해 주세요."
            />
          </div>
        </div>
      </div>
      <div className={cx("button_box")}>
        {id ? (
          <button className={cx("button")} onClick={handleEdit}>
            소식 수정
          </button>
        ) : (
          <button className={cx("button")} onClick={handleSubmit}>
            소식 추가
          </button>
        )}
      </div>
      {/* ✅ 미리보기 모달 */}
      {previewImage && (
        <div className={cx("preview_modal")}>
          <div
            className={cx("preview_overlay")}
            onClick={() => handlePreview(null)}
          />
          <div className={cx("preview_content")}>
            <button
              className={cx("preview_close_button")}
              onClick={() => handlePreview(null)}
            >
              <FaTimes />
            </button>
            <img
              src={previewImage}
              alt="preview"
              className={cx("preview_image")}
            />
          </div>
        </div>
      )}
    </>
  );
}
